import { getCookie, setCookie } from './utils/cookies'
import { CookieSettingsOptions } from './utils/parseOptions'
import getCookieSettings, {
  COOKIE_SETTINGS_NAME,
} from './utils/getCookieSettings'
import triggerEvent, {
  COOKIE_CONSENT_EVENT,
  TRIGGER_AND_CLOSE_MODAL_EVENT,
} from './utils/triggerEvent'
import {
  getCookieConsentOptions,
  getCookieSettingsOptions,
} from './utils/options'
import './CookieSettings.scss'

export default class CookieSettings {
  static self: CookieSettings

  _isOpen = false
  options: CookieSettingsOptions
  cookieSettings: { [key: string]: boolean }

  constructor() {
    this.options = getCookieSettingsOptions()
    this.cookieSettings = getCookieSettings()
    this.render()
    // console.log({ cookieSettings: this.cookieSettings })
  }

  static getInstance() {
    const self = this.self || new CookieSettings()
    this.self = self
    self.render()
    return self
  }

  private close() {
    this._isOpen = false
    $('[data-source=ta2021-cookie-settings]').remove()
    $('body').removeClass('ta-cc-modal-open')
    $('#ta-cc-modal-accept-settings').off('click')
  }

  private render() {
    const {
      color,
      settings,
      settingsAcceptButton,
      settingsBodyTextHtml,
      settingsTitleTextHtml,
    } = this.options
    if (this._isOpen) return
    this._isOpen = true

    const template = `<style data-source="ta2021-cookie-settings">
    .ta-cc-switch input:checked + .ta-cc-slider {
      background-color: ${color};
    } .ta-cc-modal-btn-exit:hover { background-color: ${color}; color: white; }
    </style><div id="ta-cc-modal" class="ta-cc-modal {{className}}" data-source="ta2021-cookie-settings"><div class="ta-cc-modal-title">${settingsTitleTextHtml}<button type="button" class="ta-cc-modal-btn-exit"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button></div><div class="ta-cc-modal-body"><p>${settingsBodyTextHtml}</p>
    ${settings.map(
      ({ content, id, title }) => `
    <div class="ta-cc-modal-collapse">
      <div class="ta-cc-modal-collapse-header">
        <div class="ta-cc-modal-collapse-header-title">${title}</div>
        ${
          id
            ? `<div class="ta-cc-switch">
          <input type="checkbox" class="ta-cc-checkbox" id="checkbox-${id}" aria-label="${id}" data-id="checkbox-${id}" role="switch" aria-controls="checkbox-${id}" aria-labelledby="checkbox-${id}" ${
                this.cookieSettings[id] ? 'checked' : ''
              }>
          <label for="checkbox-${id}" class="ta-cc-slider"></label>
        </div>`
            : ''
        }
      </div>
      <div class="ta-cc-modal-collapse-body"><p>${content}</p></div>
    </div>
    `
    )}
    
  </div><div class="ta-cc-modal-footer"><button type="input" class="ta-cc-modal-button" id="ta-cc-modal-accept-settings" style="background-color: ${color};border: 1px solid ${color}">${settingsAcceptButton}</button></div></div>`

    $(template).appendTo('body')
    $('.ta-cc-modal-collapse-header').on('click', function () {
      const $this = $(this)
      const $body = $this.parent().find('.ta-cc-modal-collapse-body')
      const $collapse = $body.parent('.ta-cc-modal-collapse')
      if ($collapse.hasClass('show')) {
        $collapse.removeClass('show')
        $body.css('max-height', 0)
      } else {
        $collapse.addClass('show')
        $body.css('max-height', $body[0].scrollHeight)
      }
    })

    $('.ta-cc-modal-btn-exit').on('click', () => {
      if (getCookie(getCookieConsentOptions().cookieName)) {
        this.close()
      } else {
        this.close()
        triggerEvent(COOKIE_CONSENT_EVENT)
      }
    })

    $('#ta-cc-modal-accept-settings').on('click', () => {
      // Estraggo tutte le opzioni
      if (!this._isOpen) return
      const newCookieSettings = this.getOptionsToJSON()
      setCookie(COOKIE_SETTINGS_NAME, newCookieSettings)
      // console.log('setCookie', newCookieSettings, COOKIE_SETTINGS_NAME)
      triggerEvent(TRIGGER_AND_CLOSE_MODAL_EVENT)
      this.close()
    })

    $('body').addClass('ta-cc-modal-open')
  }

  getOptionsToJSON() {
    const { cookieSettings } = this
    Array.from($('.ta-cc-modal-collapse-header input')).map((el) => {
      const $this = $(el)
      const id = $this.attr('data-id')?.replace('checkbox-', '') || ''
      const checked = !!$this.prop('checked')
      cookieSettings[id] = checked
    })

    return JSON.stringify(cookieSettings)
  }
}
